import { Grid2 } from "@mui/material";
import StatusRow from "./StatusRow.js";
import StatusIcon from "./StatusIcon.js";
import HeaderBar from "../Shared/HeaderBar/HeaderBar.js";
import NavigationBar from "../Shared/NavigationBar/NavigationBar.js"

export default function DashboardPage() {
  const status = Math.random() < 0.5 ? "alert" : "none";
  return (
    <>
      <HeaderBar></HeaderBar>
      <Grid2 container={true} paddingTop={'1em'} justifyContent={'center'} alignItems={'center'} direction={'row'} wrap={"wrap"} spacing={1} id={"DashboardPageGrid"}>
        <StatusRow items={["BA Status", <StatusIcon status={status} />]} />
        <StatusRow items={["Past 30 Days", 28000]} />
        <StatusRow items={["Peak 24 Hours", 1490]} />
        <StatusRow items={["All time peak", 5300]} />
        <StatusRow items={["Total 3.0", 121]} />
        <StatusRow items={["Total 1.0", 58]} />
      </Grid2>
      <br/><br/><br/>
      <NavigationBar></NavigationBar>
    </>
  );
}
